import { http } from "@/lib/http";
export function fetchPromotions() {
  return http.get("/api/promotions").then((res) => res.data);
}
export function fetchPromotion(id) {
  return http.get(`/api/promotions/${id}`).then((res) => res.data);
}
export function addPromotion(payload) {
  return http.post("/api/promotions/add", payload).then((res) => res.data);
}
export function savePromotion(payload) {
  return http.post("/api/promotions/save", payload).then((res) => res.data);
}
export function deletePromotion(id) {
  return http.post("/api/promotions/delete", { id }).then((res) => res.data);
}
